import { styled } from "styled-components";

const ScrollChapterWrapper = styled.article`
  width: 100%;
`;

export default ScrollChapterWrapper;
